export * from './terminalNumbers.interface';
export * from './validate-customer-context-data.function';
